<template>
  <div class="my-2">
    <v-toolbar flat color="white">
      <v-btn color="primary" round class="white--text" @click="addIspModalFunction()">Link ISP</v-btn>
      <v-spacer></v-spacer>
      <v-text-field label="Search" v-model="search"></v-text-field>
    </v-toolbar>
    <v-data-table
      :items="ispList"
      :headers="headers"
      min-width="1000px"
      :rows-per-page-items="[25, 50, 100, 250]"
      :key="key"
      :search="search"
      item-key="name"
      align-center
      style="cursor: pointer"
      disable-initial-sort
    >
      <template v-slot:items="props">
        <!-- <td class="text-xs-center">
            <v-chip color="light-green" class="white--text" v-if="props.item.isActive" @click="updateStatus(props.item)">Active</v-chip>
            <v-chip color="red" class="white--text" v-else @click="updateStatus(props.item)">Inactive</v-chip>
        </td>-->
        <td class="text-xs-center" @click="editModal(props.item)">{{props.item.virtualIsp.name}}</td>
        <td class="text-xs-center" @click="editModal(props.item)">
          <v-chip
            color="light-green"
            class="white--text"
            v-for="region in props.item.regions.filter(x=>x.isActive)"
            :key="region.id"
          >{{region.region.name}}</v-chip>
        </td>
      </template>
    </v-data-table>
    <v-dialog v-model="addIspModal" width="750px" persistent>
      <v-card>
        <v-toolbar flat color="primary">
          <h3 class="title white--text">Link ISP</h3>
          <v-spacer></v-spacer>
          <v-btn flat color="white" @click="addIspModal=false, item={}">X</v-btn>
        </v-toolbar>
        <v-card-text>
          <v-layout justify-center wrap>
            <v-flex xs5 mx-1>
              <v-autocomplete
                :items="allIspList"
                label="ISP"
                item-text="name"
                item-value="id"
                v-model="item.virtualIspId"
              ></v-autocomplete>
            </v-flex>
            <v-flex xs6 mx-1>
                <h3 class="grey--text">Shared Regions:</h3>
                <v-list>
                    <v-list-tile  v-for="region in selectedRegions" :key="region.id">
                        <v-list-tile-content>{{region.name}}</v-list-tile-content>
                        <v-list-tile-action> <v-checkbox v-model="region.isActive"></v-checkbox></v-list-tile-action>
                    </v-list-tile>
                </v-list>
            </v-flex>
          </v-layout>
          <v-card-actions>
            <v-layout justify-center>
              <v-btn
                v-if="item.virtualIspId"
                round
                color="primary"
                @click="addIspToVirtualNetwork(item)"
              >Add Link</v-btn>
              <v-btn v-else round color="primary" disabled>Add Link</v-btn>
            </v-layout>
          </v-card-actions>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog v-model="editIspModal" width="750px" persistent>
      <v-card>
        <v-toolbar flat color="primary">
          <h3 class="title white--text" v-if="item.virtualIsp">Edit: {{item.virtualIsp.name}}</h3>
          <v-spacer></v-spacer>
          <v-btn flat color="white" @click="editIspModal=false, item={}">X</v-btn>
        </v-toolbar>
        <v-card-text>
          <v-layout justify-center wrap>
            <v-flex xs6 mx-1>
                <h3 class="grey--text">Shared Regions:</h3>
                <v-list>
                    <v-list-tile  v-for="region in selectedRegions" :key="region.id">
                        <v-list-tile-content>{{region.name}}</v-list-tile-content>
                        <v-list-tile-action> <v-checkbox v-model="region.isActive"></v-checkbox></v-list-tile-action>
                    </v-list-tile>
                </v-list>
            </v-flex>
          </v-layout>
          <v-card-actions>
            <v-layout justify-center>
              <v-btn
                round
                color="primary"
                @click="updateIsp(item)"
              >Save</v-btn>
            </v-layout>
          </v-card-actions>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import Api from "../services/Api";
export default {
  data() {
    return {
      addIspModal: false,
      editIspModal: false,
      item: {},
      ispList: [],
      allIspList: [],
      key: 0,
      regions: [],
      selectedRegions: [],
      selectableRegions: [],
      search: '',
      headers: [
        //         {
        //   text: "Status",
        //   align: "center",
        //   value: "isActive"
        // },
        {
          text: "Name",
          align: "center",
          value: "virtualIsp.name",
        },
        {
          text: "Regions",
          align: "center",
          sortable: false
        },
      ],
    };
  },
  created() {
    this.initialize();
  },
  methods: {
    async initialize() {
      await this.fetchISPList();
      this.fetchAllIspList();
      this.getRegions();
    },
    getRegions() {
      Api()
        .get("/region")
        .then((response) => {
          this.regions = response.data.sort((a, b) =>
            a.name > b.name 
              ? 1
              : b.name  > a.name 
              ? -1
              : 0
          );
        });
    },
    fetchISPList() {
      Api()
        .get("/virtualIsp")
        .then((response) => {
          this.ispList = response.data;
          this.key += 1
        });
    },
    fetchAllIspList() {
      Api()
        .get("/organisationConnection")
        .then((response) => {
          if(response.data.length>0){
          let result = response.data.map(x=>x.connectedOrganisation);
          let existingArray=this.ispList.map(y=>y.virtualIsp.id)
          this.allIspList = result.filter(x=>!existingArray.includes(x.id))
          }
        });
    },
    addIspModalFunction() {
        this.selectedRegions = this.regions.map(x=>({isActive: false, regionId: x.id, name: x.name}))
      this.addIspModal = true;
    },
    async addIspToVirtualNetwork(item) {
        this.selectedRegions = this.selectedRegions.filter(x=>x.isActive)
      let array = this.selectedRegions.map(x=>({organisationId: this.$store.state.currentOrg.org.id, virtualIspId: item.virtualIspId, regionId: x.regionId, isActive: x.isActive}))

    await Api()
        .post("/virtualIsp",{batch: array})
        .then((response) => {
          this.fetchISPList()
          this.addIspModal = false
          this.item={}
        });
    },
    updateStatus(item) {},
    async editModal(item){
        this.item = item
        let regions = this.item.regions.filter(x=>x.isActive)
        this.selectedRegions = regions.map(x=>({id: x.region.id, name: x.region.name, isActive: x.isActive, fkId: x.id, initialActiveStatus: x.isActive}))
        let selectedArray = this.selectedRegions.map(z=>z.id)
        let unselectedRegions = this.regions.filter(x=>!selectedArray.includes(x.id))
        await unselectedRegions.forEach(a=>{
            this.selectedRegions.push({id: a.id, name: a.name, isActive: false, fkId: null})
        })
        this.selectedRegions.sort((a, b) =>
            a.name > b.name 
              ? 1
              : b.name  > a.name 
              ? -1
              : 0
          );
        this.editIspModal = true
    },
    async updateIsp(item){
        let add = this.selectedRegions.filter(x=>(!x.fkId || x.initialActiveStatus != x.isActive) && x.isActive)
        let remove = this.selectedRegions.filter(x=>x.fkId && !x.isActive)
        add = await add.map(z=>({organisationId: this.$store.state.currentOrg.org.id, virtualIspId: item.virtualIsp.id, regionId: z.id, isActive: z.isActive}))
        await Api()
        .post("/virtualIsp",{batch: add})

        await remove.forEach(async x=>{
            await Api()
        .put("/virtualIsp/"+x.fkId,{isActive: false})
        })
        this.fetchISPList()
          this.editIspModal = false
          this.item={}
          this.selectedRegions = this.regions
          
    }
  },
};
</script>